import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { CompareDetail } from '@src/pages/Compare';

export const Route = createLazyFileRoute('/compare/archer')({
  component: ArcherComparePage,
});

function ArcherComparePage() {
  return (
    <DefaultLayout>
      <CompareDetail competitorId="archer" />
    </DefaultLayout>
  );
}
